import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Gauge } from "lucide-react";
import { systemCapacity } from "../../api/platform";
import { NeuCard } from "../../components/neu/Neu";

const TONE = { ok: "text-success", warning: "text-amber-400", critical: "text-destructive" };
const BAR = { ok: "bg-success", warning: "bg-amber-400", critical: "bg-destructive" };

// الطاقة الاستيعابية: عدد الموظفين الحالي مقابل السقف الآمن لهذه البنية.
export const CapacityCard = () => {
  const { t } = useTranslation();
  const [d, setData] = useState(null);

  useEffect(() => {
    systemCapacity().then(setData).catch(() => setData(null));
  }, []);

  if (!d) return null;
  const rows = [
    ["employees", `${d.employees} / ${d.employees_safe}`],
    ["safeRps", `${d.safe_rps} /s`],
    ["peak", `${d.peak_minute_checkins} (${d.peak_rps}/s)`],
    ["companies", d.companies],
    ["diskYears", d.disk_years_left == null ? "—" : `${d.disk_years_left}${d.disk_years_capped ? "+" : ""}`],
  ];

  return (
    <NeuCard data-testid="capacity-card">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <Gauge className="h-5 w-5 text-primary" />
          <div>
            <h2 className="text-lg font-black">{t("capacity.title")}</h2>
            <p className="text-xs text-muted-foreground">
              {t("capacity.subtitle", { cpu: d.cpu_count })} · {t(`capacity.bottleneck.${d.bottleneck}`)}
            </p>
          </div>
        </div>
        <span className={`text-sm font-black ${TONE[d.level]}`} data-testid="capacity-level">
          {d.utilization_percent}% · {t(`capacity.levels.${d.level}`)}
        </span>
      </div>

      <div className="mt-4 h-2 overflow-hidden rounded-full bg-border/50">
        <div
          className={`h-full rounded-full transition-[width] duration-700 ${BAR[d.level]}`}
          style={{ width: `${Math.min(d.utilization_percent, 100)}%` }}
        />
      </div>

      <div className="mt-4 grid grid-cols-2 gap-3 lg:grid-cols-5">
        {rows.map(([key, value]) => (
          <div key={key} className="neu-in rounded-2xl p-3" data-testid={`capacity-${key}`}>
            <p className="text-[10px] tracking-normal text-muted-foreground">{t(`capacity.${key}`)}</p>
            <p className="mt-1 font-mono text-sm font-semibold num">{value}</p>
          </div>
        ))}
      </div>
      {d.level !== "ok" ? (
        <p className="mt-3 text-xs text-muted-foreground" data-testid="capacity-hint">{t("capacity.scaleHint")}</p>
      ) : null}
    </NeuCard>
  );
};
